const bestSellersSwiper = new Swiper('.best-sellers__slider', {
    slidesPerView: 1,
    spaceBetween: 32,
    loop: false,
    slidesOffsetAfter: 60,

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    breakpoints: {
        0: {
            slidesPerView: 1.4,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    },
});